import { ScrollAction, StatusActions } from './types';
import { MetroContextType } from '@/classes';

/* eslint-disable import/prefer-default-export */
let scrollEventTimeout: ReturnType<typeof setTimeout> | null = null;
let scrollMetricTimeout: ReturnType<typeof setTimeout> | null = null;

type OnScrollHandlerOptions = {
  scrollTimeout: number;
  metricTimeout: number;
};

/**
 * Manage scroll events for metrics and for scroll
 * position of the feed.
 */
export function onScrollHandler(
  metroContext: MetroContextType,
  dispatch: React.Dispatch<StatusActions>,
  metric: CallableFunction,
  options: Partial<OnScrollHandlerOptions> = {},
): React.UIEventHandler<HTMLDivElement> {
  const handlerOptions = {
    scrollTimeout: 300,
    metricTimeout: 1000,
    ...options,
  };
  return (event) => {
    if (scrollEventTimeout !== null) {
      clearTimeout(scrollEventTimeout);
    }

    if (scrollMetricTimeout) {
      clearTimeout(scrollMetricTimeout);
    }

    // react will not keep the target available if we don't
    // include the .persist() option
    event.persist();

    // delay checking if the feed is at the top or in "scrolled" position
    scrollEventTimeout = setTimeout(() => {
      const action: ScrollAction = { type: 'scroll', payload: { position: 'top' } };
      if ((event.target as HTMLDivElement).scrollTop !== 0) {
        action.payload.position = 'scrolled';
      }
      dispatch(action);
      scrollEventTimeout = null;
    }, handlerOptions.scrollTimeout);

    // fire a metric if the user scrolled and has stopped for over 1 second
    scrollMetricTimeout = setTimeout(() => {
      metric('livefire.scroll', metroContext)();
      scrollMetricTimeout = null;
    }, handlerOptions.metricTimeout);
  };
}
